import React, { Component } from "react";
import dayjs from "dayjs";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import { Button } from "ui-neumorphism";
class MessageA1 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let text = (this.props.entry && this.props.entry.text) || "";
    let switchBot =
      this.props.entry?.data && JSON.parse(this.props.entry.data).switchBot;
    //    let text =`<img src="https://picsum.photos/id/237/200/300">`
    if (this.props.entry && this.props.entry.keyword) {
      text = text;
    }
    return (
      <div
        id="btns"
        className={this.messageContainerClassName()}
        style={this.messageContainerStyle()}
      >
        <button
          disabled={this.props.disabled}
          className={this.messageBoxClassName() + " btn-check"}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          style={this.messageBoxStyle()}
          {...(this.isActiveConversation() && {
            onClick: (e) => {
              switchBot ? this.props.switchBot() : this.onMessageSend(e);
            },
          })}
        >
          {text}
          <br />
        </button>
        {this.props.isLastEntry && this.props.sentTimestamp && (
          <time
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs
              .unix(Math.trunc(this.props.sentTimestamp / 1000))
              .format("DD MMM h:mm a")}
          </time>
        )}
      </div>
    );
  }

  onMouseEnter = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    const designDetails = this.props.config.designDetails;
    e.target.style.color = isNullOrUndefined(
      designDetails.buttonHighlightTextColor
    )
      ? "#f8f5f5"
      : designDetails.buttonHighlightTextColor;
    e.target.style.background = isNullOrUndefined(
      designDetails.buttonHighlightBackgroundColor
    )
      ? "#2935dd"
      : designDetails.buttonHighlightBackgroundColor;
  };

  onMouseLeave = (e) => {
    if (!e.target) {
      return;
    }
    // if (e.target.disabled === true) { return }
    const designDetails = this.props.config.designDetails;

    e.target.style.color = isNullOrUndefined(designDetails.buttonTextColor)
      ? "#0092ed"
      : designDetails.buttonTextColor;
    e.target.style.background = isNullOrUndefined(
      designDetails.buttonBackgroundColor
    )
      ? "#fff"
      : designDetails.buttonBackgroundColor;
  };

  messageTimeClassName = () => {
    return "s360-message-time-received";
    // switch (this.props.message.type) {
    //     // case MessageType.sent: return "s360-message-time-sent";
    //     // case MessageType.received: return "s360-message-time-received";
    //     // case MessageType.info: return "s360-message-time-info";
    //     default: return "";
    // }
  };

  messageBoxClassName = () => {
    //return "s360-message-box-received";
    return "btn btn-chat";
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-box-sent";
    //     case MessageType.received: return "s360-message-box-received";
    //     case MessageType.info: return "s360-message-box-info";
    //     default: return "";
    // }
  };

  messageContainerClassName = () => {
    return this.props.config.autoFullScreen
      ? "s360-message-cotainer-received-fs"
      : "s360-message-cotainer-received";
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-cotainer-sent";
    //     case MessageType.received: return "s360-message-cotainer-received";
    //     case MessageType.info: return "s360-message-cotainer-info";
    //     default: return "";
    // }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    const designDetials = this.props.config.designDetails;
    let styleData = {
      // background: config.designDetails.senderMessageColor,
      fontFamily: config.designDetails.SenderMessageFont,
      fontSize: config.designDetails.SenderMessageFontSize,
      borderWidth: "1px",
      borderStyle: "solid",
      // color: config.designDetails.senderMessageFontColor,
      // height:          isNullOrUndefined(designDetials.buttonHeight)          ? "auto" : designDetials.buttonHeight,
      borderColor: isNullOrUndefined(designDetials.buttonBorderColor)
        ? "#0092ed"
        : designDetials.buttonBorderColor,
      width: isNullOrUndefined(designDetials.buttonWidth)
        ? "fit-content"
        : designDetials.buttonWidth,
      borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius)
        ? 20
        : designDetials.buttonBorderRadius,
      color: isNullOrUndefined(designDetials.buttonTextColor)
        ? "#0092ed"
        : designDetials.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor)
        ? "#fff"
        : designDetials.buttonBackgroundColor,
      fontWeight: isNullOrUndefined(designDetials.senderFontWeight)
        ? "500"
        : designDetials.senderFontWeight,
      textAlign: "left",
      // boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px inset'
    };
    // switch (this.props.message.type) {
    //     case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
    //     case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
    //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     default: return {}
    // }
    return styleData;
  };

  messageContainerStyle = () => {
    // let config = this.props.config
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    return {
      fontFamily: config.designDetails.messageFont,
      fontSize: config.designDetails.messageTimeFontSize,
      color: config.designDetails.messageTimeFontColor,
    };
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    // switch (this.props.message.type) {
    //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     default: return {}
    // }
  };

  onMessageSend = () => {
    this.props.actions.sendMessageWithCode(
      this.props.entry.keyword,
      this.props.entry.text
    );
    var n = document.getElementsByClassName("btn btn-chat");
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // this.onMouseLeave({ "target": n[i]});
    }
  };

  isActiveConversation = () => {
    let isClosed =
      (this.props.activeConversation &&
        this.props.activeConversation.active != null &&
        this.props.activeConversation.active !== undefined &&
        this.props.activeConversation.active === false) ||
      this.props.isConversationClosed;
    return !isClosed;
  };
}

export default MessageA1;
